/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface LieuFormationFichierUploadDto
 */
export interface LieuFormationFichierUploadDto {
    /**
     * 
     * @type {FileUploadDto}
     * @memberof LieuFormationFichierUploadDto
     */
    file?: FileUploadDto;
    /**
     * 
     * @type {number}
     * @memberof LieuFormationFichierUploadDto
     */
    idlieuFormationFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof LieuFormationFichierUploadDto
     */
    idlieuFormation?: number;
    /**
     * 
     * @type {number}
     * @memberof LieuFormationFichierUploadDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof LieuFormationFichierUploadDto
     */
    idtypeLieuFormationFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof LieuFormationFichierUploadDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the LieuFormationFichierUploadDto interface.
 */
export function instanceOfLieuFormationFichierUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LieuFormationFichierUploadDtoFromJSON(json: any): LieuFormationFichierUploadDto {
    return LieuFormationFichierUploadDtoFromJSONTyped(json, false);
}

export function LieuFormationFichierUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LieuFormationFichierUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : FileUploadDtoFromJSON(json['file']),
        'idlieuFormationFichier': !exists(json, 'idlieuFormationFichier') ? undefined : json['idlieuFormationFichier'],
        'idlieuFormation': !exists(json, 'idlieuFormation') ? undefined : json['idlieuFormation'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeLieuFormationFichier': !exists(json, 'idtypeLieuFormationFichier') ? undefined : json['idtypeLieuFormationFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function LieuFormationFichierUploadDtoToJSON(value?: LieuFormationFichierUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FileUploadDtoToJSON(value.file),
        'idlieuFormationFichier': value.idlieuFormationFichier,
        'idlieuFormation': value.idlieuFormation,
        'idfichier': value.idfichier,
        'idtypeLieuFormationFichier': value.idtypeLieuFormationFichier,
        'fileName': value.fileName,
    };
}

